var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 90,
    viewBox: "0 0 64 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 42.75C29.0163 42.75 26.1548 41.5647 24.045 39.455C21.9353 37.3452 20.75 34.4837 20.75 31.5C20.75 28.5163 21.9353 25.6548 24.045 23.545C26.1548 21.4353 29.0163 20.25 32 20.25C34.9837 20.25 37.8452 21.4353 39.955 23.545C42.0647 25.6548 43.25 28.5163 43.25 31.5C43.25 32.9774 42.959 34.4403 42.3936 35.8052C41.8283 37.1701 40.9996 38.4103 39.955 39.455C38.9103 40.4996 37.6701 41.3283 36.3052 41.8936C34.9403 42.459 33.4774 42.75 32 42.75ZM32 0C23.6457 0 15.6335 3.31874 9.72614 9.22614C3.81874 15.1335 0.5 23.1457 0.5 31.5C0.5 55.125 32 90 32 90C32 90 63.5 55.125 63.5 31.5C63.5 23.1457 60.1813 15.1335 54.2739 9.22614C48.3665 3.31874 40.3543 0 32 0Z",
    fill: "url(#paint0_linear_340_12929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_12929",
    x1: 63.6964,
    y1: 89.6086,
    x2: 0.305112,
    y2: 0.391206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B665C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.66daf2afc8d6f8a165f11aef36ad556d.svg";
export { ForwardRef as ReactComponent };